// import dateFormat from "@/assets/js/utils/dateFormat";
import API from "../../../../config/api";
export default {
    inject: {
        reload: 'reload'
    },
    data() {
        return {
            info: {
                table: {
                    data: [],
                    columns: [{
                        label: '产品名称',
                        prop: 'label',
                        width: 140,
                    },
                        {
                            label: '公司额度',
                            prop: 'rowTotal',
                            width: 140,
                        },
                        {
                            label: '使用条数',
                            prop: 'rowUsed',
                            width: 140,
                        },
                        {
                            label: '剩余额度',
                            prop: 'rowRemain',
                            width: 140,
                        },
                    ],
                    loading: false,
                    currentPage: 1,
                    total: 0,
                    pageSize: 10,
                },
            },
            sysVariableList:[],
            orderRowInfo: {
                companyId: 0,
                type:null,
            },
            dialogLoading: false,
            dialogVisible: false,
        }
    },
    mounted() {
        this.getSysVariableList()
        this.getBuyInfo()
    },
    methods: {
        // 获取当前公司所有的系统变量
        getSysVariableList() {
            console.log("获取公司一级项目")
            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }

            let data = {
                companyId: this.companyId,
            }
            console.log(data)
            this.$axiosRequest({
                url: API.getSysVariableList,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    console.log(res.data)
                    this.sysVariableList = res.data["sysVariableList"]

                }
            });
        },
        getBuyInfo() {
            this.info.table.loading = true
            let header = {
                "Content-Type": "application/x-www-form-urlencoded"
            }
            let data = {
                companyId: this.companyId
            }
            this.$axiosRequest({
                url: API.getBuyInfo,
                method: 'POST',
                data: data,
                header: header,
                success: res => {
                    let getBuyInfoTable = [];
                    let VariableData = {};
                    VariableData.label = "变量个数";
                    VariableData.rowTotal = res.data.VariableCount;
                    VariableData.rowUsed  = res.data.VariableUsedCount;
                    VariableData.rowRemain = res.data.VariableCount - res.data.VariableUsedCount;
                    VariableData.type  = 0;
                    getBuyInfoTable.push(VariableData);
                    let VariableValue={}
                    VariableValue.label = "变量历史值";
                    VariableValue.rowTotal = res.data.VariableValueCount;
                    VariableValue.rowUsed  = res.data.VariableValueUsedCount;
                    VariableValue.rowRemain  = res.data.VariableValueCount-res.data.VariableValueUsedCount;
                    VariableValue.type  = 2;
                    getBuyInfoTable.push(VariableValue);
                    let message = {};
                    message.label = "短信条数";
                    message.rowTotal = res.data.MessageCount;
                    message.rowUsed  = res.data.MessageSendCount;
                    message.rowRemain  = res.data.MessageCount-res.data.MessageSendCount;
                    message.type  = 3;
                    getBuyInfoTable.push(message);
                    // let yearMoney = {};
                    // yearMoney.label = "公司年费";
                    // yearMoney.rowTotal = res.data.overdue_date;
                    // yearMoney.rowUsed  = this.sysVariableList[0].curDate;
                    // yearMoney.type  = 1;
                    // getBuyInfoTable.push(yearMoney);
                    this.info.table.data = getBuyInfoTable
                    this.info.table.total = data.total
                    this.info.table.loading = false

                }
            });

        },
        openDialog(item) {
            this.orderRowInfo.companyId = this.companyId;
            this.orderRowInfo.type = item.type;
            this.dialogVisible = true
        },
        handlePayDone() {
            this.$message.success('购买成功')
            this.reload()
        },
    }
}
